import { Routes } from '@angular/router';
import { AssessmentGuideComponent } from './assessment-guide/assessment-guide.component';
import { FuzzyNameMatchingComponent } from './fuzzy-name-matching/fuzzy-name-matching.component';

export const userGuideRoutes: Routes = [
  {
    path: 'user-guides',
    children: [
      { path: 'assessment-guide', component: AssessmentGuideComponent },
      { path: 'fuzzy-name-matching', component: FuzzyNameMatchingComponent },
      { path: '', redirectTo: 'assessment-guide', pathMatch: 'full' },
    ],
  },
];
